export default "__VITE_ASSET__BGDjvWyN__"